/* eslint-disable-next-line @typescript-eslint/no-restricted-imports  -- (https://aka.ms/OWALintWiki)
 * Baseline - Migrating deprecated icons: https://outlookweb.visualstudio.com/Outlook%20Web/_wiki/wikis/Outlook%20Web.wiki/9297/Migrating-deprecated-icons-in-client-web
 *	> 'ControlIcons' import from owa-control-icons is restricted. Use JSX icons from @fluentui/react-icons, otherwise from owa-fluent-icons-svg if they can only be reference by string. */
import { type ControlIcons } from 'owa-control-icons';
import { ImageRegular } from '@fluentui/react-icons';
import type { IIconProps } from '@fluentui/react/lib/Icon';
/* eslint-disable-next-line @fluentui/react-components/prefer-fluentui-v9 -- (https://aka.ms/OWALintWiki)
 * Baseline. DO NOT COPY AND PASTE! Substitute this line with an explanation or resolve the problem by using v9 components instead
 *	> Avoid using Icon from '@fluentui/react', as this package has already migrated to Fluent UI 9. Use a JSX SVG icon from '@fluentui/react-icons' instead. */
import { Icon, IconType } from '@fluentui/react/lib/Icon';
import { ImageFit } from '@fluentui/react/lib/Image';

import { fallbackIcon } from './SurfaceActionIcon.scss';

export const getIconProps = (srcUrl: string): IIconProps => {
    return {
        iconType: IconType.Image,
        imageProps: {
            src: srcUrl,
            width: 16,
            height: 16,
            imageFit: ImageFit.contain,
            shouldFadeIn: false,
        },
        styles: {
            root: {
                width: '16px !important',
                height: '16px !important',
            },
        },
        imageErrorAs: () => (
            <Icon className={fallbackIcon} iconName={'Photo2'} iconType={IconType.Default} />
        ),
    };
};

interface IconPropsV9 {
    imageProps: {
        src: string;
        width: number;
        height: number;
        imageErrorAs: () => React.JSX.Element;
    };
}

export const getIconPropsV9 = (srcUrl: string | undefined): IconPropsV9 | undefined => {
    if (!srcUrl) {
        return;
    }
    return {
        imageProps: {
            src: srcUrl,
            width: 16,
            height: 16,
            imageErrorAs: (): React.JSX.Element => <ImageRegular className={fallbackIcon} />,
        },
    };
};
